import { Button, Typography } from 'antd';
import { useLocation, useNavigate } from 'react-router';
import tw from 'twin.macro';

import { PATH } from '@/Route';
import Card from '@/components/Card';
import { ProductItemBox } from '@/components/product/ProductItem';
import BankTransferItem from '@/components/product/ProductItem/BankTransferItem';
import type { GetProductResponse } from '@/types/partner';

const ProductSuccess = () => {
  const { state: data } = useLocation() as {
    state: { orderId: number } & GetProductResponse;
  };
  const navigate = useNavigate();
  return (
    <section css={tw`flex flex-col gap-y-[32px]`}>
      <ProductItemBox
        productId={data.id}
        title=""
        url={data.bannerImageUrl}
        name={data.name}
        summary={data.summary}
        price={data.price}
        discountPrice={data.discountPrice}
      />

      <Card>
        <BankTransferItem
          title={
            <Typography.Text css={tw`text-[#000]`}>
              원활한 확인을 위해 파트너 명의로 입금해주세요. 입금 확인 후,
              신청하신 정보로 담당자가 연락드리겠습니다.
            </Typography.Text>
          }
        />
      </Card>

      <div css={tw`m-auto`}>
        <Button
          type="primary"
          onClick={() => {
            navigate(
              `${PATH.MARKETING_PRODUCT.ORDER_HISTORY}/${data.orderId}`,
              {
                replace: true,
              }
            );
          }}
        >
          확인
        </Button>
      </div>
    </section>
  );
};

export default ProductSuccess;
